// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a4deab8","418":"562ddacc","455":"508acd46","507":"f9f01f5f","977":"06cb0a55"}[chunkId] + ".chunk.js";
};